export default __webpack_public_path__ + "static/media/mention.4e33c5b2.svg";